import React, { useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import { PortableText } from "@portabletext/react"
import { getGatsbyImageData } from "gatsby-source-sanity"
import { useStaticQuery, graphql } from "gatsby"
import { FiInstagram, FiFacebook, FiTwitter } from "react-icons/fi";

const motionSection = {
  hidden: {
    opacity: 0,
    // y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const motionImage = {
  hidden: {
    scale: 1.1,
    opacity: 0,
    // rotate: 20,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 1,
      // ease: [0.87, 0, 0.13, 1],
    },
  },
}

const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const desc = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}

const eventSocialGrid = ({ block }) => {
  const data = useStaticQuery(graphql`
    query eventSocialGridQuery {
      allSanityLocations {
        nodes {
          featuredImage {
            asset {
              altText
              gatsbyImageData
            }
          }
          sidebarTitle
          sidebarText
          sidebarAddress
          sidebarAddressURL
          instagram
          twitter
          facebook
          title
          slug {
            current
            _type
            _key
          }
        }
      }
    }
  `)

  const { heading, description, _rawPortableText } = block
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
      className="section multicolumn"
    >
      {/* <div className="grid grid-cols-3"> */}

      <div className="module-image-text-carousel__content flex flex-col justify-center mb-8 items-center text-center container max-w-screen-md">
        <h2 className="w-fit h2 mb-6 relative">
          <motion.div variants={title}>{heading}</motion.div>
          <motion.div
            variants={underline}
            className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
          />
        </h2>
        <motion.p variants={desc}>{description}</motion.p>
      </div>

      <div className="container">
        <motion.div variants={desc} className="mt-8">
          <div className="grid lg:grid-cols-3 gap-8">
            {data.allSanityLocations.nodes.map((item, index) => {
              return (
                <div className="flex flex-col items-center relative">

                    <GatsbyImage
                      image={item.featuredImage.asset.gatsbyImageData}
                      alt={item.featuredImage.asset.altText}
                      className=" aspect-w-1 aspect-h-1 w-full h-full rounded-full object-cover after:content-[''] after:absolute after:inset-0 after:bg-black/40"
                    />
                  

                  <div className="absolute inset-0 flex items-center justify-center text-white">
                    <div className="text-center">
                      <h3 className="h3">{item.title}</h3>
                      <div className="flex gap-3 mt-4 justify-center">
                        {item.instagram && (
                          <a href={item.instagram}><FiInstagram className="w-[30px] h-[30px]" /></a>
                        )}

                        {item.facebook && (
                          <a href={item.facebook}><FiFacebook className="w-[30px] h-[30px]"/></a>
                        )}
                        {item.twitter && (
                          <a href={item.twitter}><FiTwitter className="w-[30px] h-[30px]"/></a>
                        )}
                      </div>
                    </div>
                    
                  </div>
                  
                  
                </div>
              )}
            )}
          </div>
        </motion.div>
      </div>
    </motion.section>
  )
}

export default eventSocialGrid
